import {useEffect, useState} from "react";
import {$userId} from "./useAuth";

interface UseSocketProps {
    sendMessageCallback: () => void;
}

export const useSocket = ({sendMessageCallback}:UseSocketProps) =>{
    const [socket, setSocket] = useState<WebSocket | null>(null);
    const [isConnected, setIsConnected] = useState(false);
    const [partner, setPartner] = useState(false);
    const [typing, setPartnerTyping] = useState(false);

    const userId = $userId.getState();

    useEffect(() => {
        //dev
        //const socketConnection = new WebSocket('ws://127.0.0.1:9001');

        //prod
        const socketConnection = new WebSocket('wss://api.exhot.ru:9000');

        setSocket(socketConnection)

        socketConnection.onopen = () => {
            const user = {action: 'REGISTER', userId: userId}
            const onlineStatus = {action: 'STATUS', data: true, userId:userId}
            socketConnection.send(JSON.stringify(user))
            socketConnection.send(JSON.stringify(onlineStatus))
            setIsConnected(true);
        };

        socketConnection.onclose = () => {
            console.log('Соединение с WebSocket закрыто');
            setIsConnected(false);
        };

        socketConnection.onerror = (error) => {
            console.error('Ошибка WebSocket:', error);
        };

        socketConnection.addEventListener("message", event => {
            if(event.data == 'updateMessages'){
                sendMessageCallback()
            }
            function isJson(str: string) {
                try {
                    JSON.parse(str);
                    return true;
                } catch (e) {
                    return false;
                }
            }
            if(isJson(event.data)){
                const data = JSON.parse(event.data);
                if(data.event === 'updateOnlineStatus'){
                    if(data.count > 3){
                        setPartner(data.status)
                    }else{
                        setPartner(false)
                    }
                }
            }
            if(isJson(event.data)){
                const data = JSON.parse(event.data);
                if(data.event === 'updateMessages'){
                    sendMessageCallback()
                    if(data.count > 3){
                        setPartner(data.status)
                    }else{
                        setPartner(false)
                    }
                }
            }
            if(isJson(event.data)){
                const data = JSON.parse(event.data);
                if(data.event === 'updateTypingStatus'){
                    sendMessageCallback()
                    if(data.userId != $userId.getState()){
                        setPartnerTyping(data.status)
                    }
                }
            }
        });
        return () => {
            socketConnection.close();
        };
    }, []);

    const sendSocketMessage = (message: string) => {
        if (socket?.readyState === WebSocket.OPEN) {
            socket.send(message);
        }
    };

    return {
        socket,
        isConnected,
        partner,
        typing,
        sendSocketMessage
    }
}
